export function hotkey(node: HTMLElement, keys: string[] | (() => void)) {
  const callback = typeof keys === 'function' ? keys : () => node.click()
  const shortcuts = typeof keys === 'function' ? [] : keys
  
  const handleKeydown = (e: KeyboardEvent) => {
    const isCtrlOrCmd = e.ctrlKey || e.metaKey
    
    if (isCtrlOrCmd && e.key === 'k' && (shortcuts.includes('cmd+k') || shortcuts.includes('ctrl+k'))) {
      e.preventDefault()
      e.stopPropagation()
      callback()
    } else if (isCtrlOrCmd && e.key === 'Enter' && shortcuts.includes('cmd+enter')) {
      e.preventDefault()
      e.stopPropagation()
      callback()
    }
  }
  
  window.addEventListener('keydown', handleKeydown)
  
  return {
    destroy() {
      window.removeEventListener('keydown', handleKeydown)
    }
  }
}